import React from "react";

export default function HpiForm({ hpi, meds, pmh, onChangeHpi, onChangeMeds, onChangePmh }) {
  return (
    <div className="cn-card">
      <h3>History of Present Illness (HPI)</h3>
      <label>General</label>
      <textarea rows={2} value={hpi.general} onChange={(e)=>onChangeHpi({...hpi, general:e.target.value})}/>
      <label>Transitional Care Management (summary)</label>
      <textarea rows={2} value={hpi.tcm} onChange={(e)=>onChangeHpi({...hpi, tcm:e.target.value})}/>

      <div className="row" style={{marginTop:8}}>
        <div>
          <label>
            <input type="checkbox" checked={meds.allReviewedAndReconciled}
              onChange={(e)=>onChangeMeds({...meds, allReviewedAndReconciled:e.target.checked})}/>
            {" "}All medications reviewed and reconciled
          </label>
        </div>
      </div>
      <label>Current Medications</label>
      <textarea rows={2} value={meds.text} onChange={(e)=>onChangeMeds({...meds, text:e.target.value})}/>

      <div className="row" style={{marginTop:8}}>
        <div>
          <label>
            <input type="checkbox" checked={pmh.noChangeReviewed}
              onChange={(e)=>onChangePmh({...pmh, noChangeReviewed:e.target.checked})}/>
            {" "}No change in Past Medical History, reviewed
          </label>
        </div>
      </div>
      <label>Past Medical History</label>
      <textarea rows={2} value={pmh.text} onChange={(e)=>onChangePmh({...pmh, text:e.target.value})}/>
    </div>
  );
}
